import { render, staticRenderFns } from "./DetailedAppointment.vue?vue&type=template&id=87ad8208"
import script from "./DetailedAppointment.vue?vue&type=script&lang=js"
export * from "./DetailedAppointment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports